import { User } from 'state/user/UserTypes';
import { AppState } from 'state/store';

export const selectUsers = ({ users }: AppState): User[] => users.users;

export const selectIsViewingUserDetails = ({ users }: AppState): boolean => users.isViewingUserDetails;

export const selectUserIndexBeingViewed = ({ users }: AppState): number | undefined => users.userIndexBeingViewed;

export const selectTotalPages = ({ users }: AppState): number => users.totalPages;

export const selectTotalUsers = ({ users }: AppState): number | undefined => users.totalUsers;
